{
  "version": 1,
  "asset_id": "528e9882-5ef9-4183-9d98-f43e4a014057",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/528e9882-5ef9-4183-9d98-f43e4a014057/hiatal-normal-es-v3-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/528e9882-5ef9-4183-9d98-f43e4a014057/hiatal-normal-es-v3-800.webp",
  "original_filename": "hiatal-normal-es-v3-800.webp",
  "size": 85900,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:12:11Z"
}
